import * as React from 'react';

interface Props {
    size?: number;
}

export function CircularProgress(props: Props) {
    const size = props.size ?? 24;

    return <div>
        <svg
            style={{margin: 'auto', background: 'none', display: 'block'}}
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            fill="#1976d2"
            width={size + "px"}
            height={size + "px"}
        >
            <circle cx="50" cy="50" r="45" strokeWidth="10" stroke="#e0e0e0" fill="none" />
            <circle
                cx="50"
                cy="50"
                r="45"
                strokeWidth="10"
                strokeLinecap="round"
                stroke="#1976d2"
                fill="none"
                strokeDasharray="283"
                strokeDashoffset="75"
            >
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 50 50"
                    to="360 50 50"
                    dur="1s"
                    repeatCount="indefinite"
                />
            </circle>
        </svg>
    </div>;
}